import { ILanguageNames } from ".";

export const SPANISH_NAMES: ILanguageNames = {
  female: [
    "Olivia",
    "Amaya",
    "Ava",
    "Isabella",
    "Luna",
    "Camila",
    "Emilia",
    "Aurora",
    "Estela",
    "Sofia",
    "Martina",
    "Lucia",
    "Luciana",
    "Elena",
    "Julieta",
    "Valeria",
    "Amelia",
    "Regina",
    "Renata",
    "Sara",
    "Antonella",
    "Lia",
    "Aitana",
    "Ximena",
    "Samantha",
    "Alma",
    "Daniela",
    "Paula",
    "Zoe",
    "Mariana",
    "Natalia",
    "Romina",
    "Julia",
    "Josefina",
    "Roma",
    "Chloe",
    "Lara",
    "Clara",
    "Delfina",
    "Miranda",
    "Fernanda",
    "Celeste",
    "Guadalupe",
    "Paulina",
    "Alba",
    "Elisa",
    "Gabriela",
  ],
  male: [
    "Santiago",
    "Xavier",
    "Jose",
    "Diego",
    "Luis",
    "Carlos",
    "Juan",
    "Emiliano",
    "Arlo",
    "Miguel",
    "Alejandro",
    "Andres",
    "Javier",
    "Jorde",
    "Francisco",
    "Manuel",
    "Fernando",
    "Elian",
    "Leonel",
    "Sergio",
    "Pedro",
    "Esteban",
    "Ruben",
    "Santana",
    "Enrique",
    "Alonzo",
    "Rio",
    "Tadeo",
    "Camilo",
    "Rey",
    "Mauricio",
    "Orlando",
    "Belen",
    "Alonso",
    "Alvaro",
    "Santos",
    "Alfonso",
    "Ernesto",
    "Zavier",
    "Joaquin",
    "Raul",
    "Emilio",
    "Ignacio",
    "Hugo",
  ],
  lastNames: [
    "García",
    "Fernandez",
    "González",
    "Rodríguez",
    "López",
    "Martínez",
    "Sánchez",
    "Pérez",
    "Martin",
    "Gómez",
    "Ruiz",
    "Hernández",
    "Jiménez",
    "Díaz",
    "Álvarez",
    "Moreno",
    "Muñoz",
    "Alonso",
    "Gutiérrez",
    "Romero",
    "Navarro",
    "Torres",
    "Dóminguez",
    "Gil",
    "Vásquez",
    "Serrano",
    "Ramos",
    "Blanco",
    "Sanz",
    "Castro",
    "Suarez",
    "Ortega",
    "Rubio",
    "Molina",
    "Delgado",
    "Ramirez",
    "Morales",
    "Ortiz",
    "Marin",
    "Iglesisas",
  ],
};
